export default {
  "Loop as a GIF": "Poner en Bucle como GIF",
  "without sound": "sin sonido",
  "Final output duration": "Duración del resultado final",
};
